/**
 * A logo do cabeçalho (§8 de 16/10, ~20h35; ORD-F-022, item 3): `docs/logo.png` da raiz, recortada nas margens e
 * gravada em public/static/ com o hash no nome (cache imutável), em AVIF e WebP, a 40 px e a 80 px de altura (1x e
 * 2x). Dados puros: o BrandLogo do app e o esboço do boot (scripts/vite/inline-boot.ts) leem daqui o mesmo tamanho,
 * para o cabeçalho não se deslocar do esboço para o app (AC-17.2-10). O nome do produto vai no `alt`.
 */
export const BRAND_LOGO = {
  width: 115,
  height: 40,
  avif: '/static/logo-40.b56af6face.avif 1x, /static/logo-80.c5ccfd7403.avif 2x',
  webp: '/static/logo-40.61f70d7960.webp 1x, /static/logo-80.1da40be8a9.webp 2x',
  src: '/static/logo-40.61f70d7960.webp',
} as const;
